import { useState, useContext, useEffect } from "react";
import { FaCalculator, FaCircle, FaEdit, FaGlobe, FaIdBadge, FaMedrt, FaPlusCircle, FaRedoAlt, FaTrashAlt, FaUmbrella, FaRegUser, FaCalendarAlt, FaClipboardList } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import AuditCompletPage from "pages/audit complet";
import Dialogs from "components/ui/dialogs/dialogs";
import { AuthContext } from "components/auth/auth-provider";
import {
  createStyledButton,
} from "components/ui/controls/button/button-styles";
import AuditCompletLogo from "./images/Audit complet.JPG";
import AuditRetaiteLogo from "./images/Audit retraite.JPG";
import AuditPrevoyanceLogo from "./images/Audit prevoyance.JPG";
import AuditRemunerationLogo from "./images/Audit remuneration.JPG";
import CalculatriceAgircArrcoLogo from "./images/Caculatrice AGIRC ARRCO.JPG";
import DeclarationPERLogo from "./images/Declaration PER.JPG";
import CorrectionPERLogo from "./images/Correction PER.JPG";
import StrategiePERLogo from "./images/Strategie PER.JPG";
import "./ListeAudits.css";
import "./AccesEtude.css";

const ListeAudits = (props) => {
  const context = useContext(AppContext);
  const [modalMakoFormation, setmodalMakoFormation] = useState(false);
  const authContext = useContext(AuthContext);

  // Fonction helper pour récupérer les informations du client depuis la liste des clients
  const getClientInfo = (dossier) => {
    // Si les informations sont directement disponibles dans le dossier
    if (dossier.Civilite && dossier.Nom && dossier.Prenom) {
      return {
        civilite: dossier.Civilite,
        nom: dossier.Nom,
        prenom: dossier.Prenom,
        found: true
      };
    }
    // Sinon, chercher dans la liste des clients avec l'IdClient
    if (dossier.IdClient && context.state.ListeClient) {
      const client = context.state.ListeClient.find(c => c.IdClient === dossier.IdClient);
      if (client) {
        return {
          civilite: client.Civilite,
          nom: client.Nom,
          prenom: client.Prenom,
          found: true
        };
      } else {
        // Debug : log si le client n'est pas trouvé
        console.warn('Client non trouvé pour IdClient', dossier.IdClient, context.state.ListeClient);
      }
    }
    // Fallback: informations manquantes
    return {
      civilite: '',
      nom: '',
      prenom: 'Client inconnu',
      found: false
    };
  };
  const [etude, setEtude] = useState("");
  useEffect(() => {
    context.handleListeDossier();
  }, []);

  // S'assurer que l'état AccesEtude est cohérent au montage du composant
  useEffect(() => {
    // Si on arrive sur la page des audits sans paramètre AccesEtude spécifique,
    // s'assurer qu'on affiche bien la page principale
    if (!props.AccesEtude || props.AccesEtude === "") {
      // Optionnel: forcer la réinitialisation si nécessaire
      if (props.SetAccessEtude) {
        props.SetAccessEtude("");
      }
    }
  }, [props.AccesEtude, props.SetAccessEtude]);

  return (
    <>
      <Column fill>
        {props.AccesEtude === "" && (
          <>
            {/* Header avec titre et sous-titre - Version avec cadre blanc */}
            <CardBox className="header-section">
              <Column fill>
                <div className="header-content">
                  <h1 className="main-title">
                    Votre gamme logicielle
                  </h1>
                  <p className="main-subtitle">
                    Choisissez votre simulateur pour accompagner vos clients
                  </p>
                </div>
              </Column>
            </CardBox>

            {/* Pack Essentiel avec design moderne */}
            <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon green-theme">
                    ⭐
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Essentiel
                    </h1>
                    <p className="pack-description">
                      Les outils indispensables pour optimiser la rémunération et la protection sociale de vos clients
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  {/* Audit Complet */}
                  <div className="audit-pack-card violet-theme" 
                  onClick={() => {
                    props.SetAccessEtude("Audit complet");
                    setEtude("audit complet");
                  }}>
                    <div className="audit-pack-card-icon">
                      🎯
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Complet
                    </h3>
                    <p className="audit-pack-card-description">
                      Analyse complète et approfondie
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Retraite */}
                  <div className="audit-pack-card blue-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit retraite");
                    setEtude("audit de retraite");
                  }}>
                    <div className="audit-pack-card-icon">
                      🌅
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Retraite
                    </h3>
                    <p className="audit-pack-card-description">
                      Optimisation retraite
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Prévoyance */}
                  <div className="audit-pack-card green-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit prévoyance");
                    setEtude("audit de prévoyance");
                  }}>
                    <div className="audit-pack-card-icon">
                      🛡️
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Prévoyance
                    </h3>
                    <p className="audit-pack-card-description">
                      Protection sociale optimale
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Audit Rémunération */}
                  <div className="audit-pack-card red-theme"
                  onClick={() => {
                    props.SetAccessEtude("Audit rémunération");
                    setEtude("audit de rémunération");
                  }}>
                    <div className="audit-pack-card-icon">
                      ⚖️
                    </div>
                    <h3 className="audit-pack-card-title">
                      Audit Rémunération
                    </h3>
                    <p className="audit-pack-card-description">
                      Équilibre salarial optimal
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>
                </Row>
              </Column>
            </CardBox>

            {/* Pack Expert avec design moderne */}
            <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon red-theme">
                    🎯
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Expert
                    </h1>
                    <p className="pack-description">
                      Outils avancés pour approfondir votre expertise
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  {/* Calculatrice AGIRC ARRCO */}
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'blue-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Calculatrice AGIRC ARRCO");
                      setEtude("calculatrice AGIRC ARRCO");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "🧮" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Calculatrice AGIRC ARRCO" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Calcul des points retraite" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Déclaration PER */}
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'violet-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Déclaration PER");
                      setEtude("déclaration PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "📋" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Déclaration PER" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Gestion déclarative PER" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Correction PER */}
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'red-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Correction plafond PER");
                      setEtude("correction plafond PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "🔧" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Correction PER" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Rectification des plafonds" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                  {/* Stratégie PER */}
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'green-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Stratégie PER");
                      setEtude("stratégie PER");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "📊" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Stratégie PER" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Optimisation stratégique" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>
                </Row>
              </Column>
            </CardBox>
            {/* Pack Expert avec design moderne */}
            {/* <CardBox className="pack-section">
              <Column fill>
                <Row className="pack-header">
                  <div className="pack-icon red-theme">
                    🎯
                  </div>
                  <Column>
                    <h1 className="pack-title">
                      Pack Expert
                    </h1>
                    <p className="pack-description">
                      Outils avancés pour approfondir votre expertise
                    </p>
                  </Column>
                </Row>
                <Row className="pack-cards-container">
                  <div className={`audit-pack-card ${authContext.utilisateur_reel?.AccesMakoFormation ? 'blue-theme' : 'gray-theme disabled'}`}
                  onClick={() => {
                    if (authContext.utilisateur_reel?.AccesMakoFormation === true) {
                      props.SetAccessEtude("Correction de carrière");
                      setEtude("correction de carrière");
                    } else {
                      setmodalMakoFormation(true);
                    }
                  }}>
                    <div className="audit-pack-card-icon">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "💼" : "🔒"}
                    </div>
                    <h3 className="audit-pack-card-title">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Correction de carrière" : "Formation requise"}
                    </h3>
                    <p className="audit-pack-card-description">
                      {authContext.utilisateur_reel?.AccesMakoFormation ? "Révision du parcours professionnel" : "Accès Premium"}
                    </p>
                    <div className="audit-pack-card-decoration"></div>
                  </div>

                </Row>
              </Column>
            </CardBox> */}
          </>
        )}
        {props.AccesEtude !== "" && (
          <>
            <CardBox>
              <Column fill>
                <Row center>
                  <Column style={{ flex: "0 0 auto", marginRight: "16px" }}>
                    <Button
                      {...createStyledButton("primary")}
                      onClick={() => {
                        context.handleNewSimulation(props.AccesEtude);
                      }}
                    >
                      <FaPlusCircle style={{ marginRight: "8px" }} />
                      Créer une nouvelle étude
                    </Button>
                  </Column>
                </Row>
              </Column>
            </CardBox>

            <CardBox>
              <Column fill>
                <Row>
                  <Column scroll fill>
                    <div className="studies-scroll">
                      <div className="studies-header">
                        <FaClipboardList className="studies-header-icon" />
                        <h3 className="studies-header-title">
                          {props.AccesEtude} (
                          {context.state.ListeDossier?.filter(Infos => Infos.TypeSimulation === props.AccesEtude).length || 0}
                          )
                        </h3>
                      </div>
                    {context.state.ListeDossier?.filter(
                      Infos => Infos.TypeSimulation === props.AccesEtude
                    ).length === 0 ? (
                      <div className="studies-empty">
                        <FaClipboardList className="studies-empty-icon" />
                        <p className="studies-empty-text">Aucune étude trouvée</p>
                      </div>
                    ) : (
                      context.state.ListeDossier?.filter(
                        Infos => Infos.TypeSimulation === props.AccesEtude
                      ).map((Infos, index) => {
                        const clientInfo = getClientInfo(Infos);
                        return (
                        <div className="study-card" key={"DOSSIER" + index}>
                          <div className="study-card-main">
                            <div className="study-card-info">
                              <div className="study-card-avatar">
                                {Infos.TypeSimulation?.[0] || "?"}
                              </div>
                              <div className="study-card-details">
                                <div className="study-card-row">
                                  <h4 className="study-card-title">{Infos.InfosDossier.LibelleDossier}</h4>
                                </div>
                                <div className="study-card-client">
                                  {clientInfo.found ? (
                                    `${clientInfo.civilite} ${clientInfo.nom} ${clientInfo.prenom}`
                                  ) : (
                                    <span style={{color:'#ef4444'}}>Client inconnu</span>
                                  )}
                                </div>
                                <div className="study-card-type">
                                  {Infos.TypeSimulation}
                                </div>
                                <div className="study-card-date">
                                  <FaCalendarAlt style={{ fontSize: "11px", color: "#666" }} />
                                  <span>Modifié le {Infos.DateAdd} à {Infos.HeureAdd}</span>
                                </div>
                              </div>
                            </div>
                            <div className="study-card-actions">
                              <Button
                                onClick={() => {
                                  context.handleOpenDossier(Infos.IdDossier);
                                }}
                                icon
                                {...createStyledButton("card-action", "cardEdit")}
                              >
                                <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                              </Button>
                              <Button
                                onClick={() => {
                                  Dialogs.confirm("Vous êtes sur le point de supprimer ce dossier. Voulez-vous continuer ?", "Suppression du dossier", () => {
                                    context.handleDeleteDossier(Infos.IdDossier);
                                  });
                                }}
                                icon
                                {...createStyledButton("card-action", "delete")}
                              >
                                <FaTrashAlt style={{ color: "#ef4444", fontSize: "12px" }} />
                              </Button>
                            </div>
                          </div>
                        </div>
                        );
                      })
                    )}
                    </div>
                  </Column>
                </Row>
              </Column>
            </CardBox>
          </>
        )}
        <Modal
          width="80%"
          height="40%"
          title="Pack formation"
          visible={modalMakoFormation}
          onClose={() => {
            setmodalMakoFormation(false);
          }}
        >
          <Column fill>
            <Row fill>
              <Column fill center className="modal-content">
                <br />
                L'accès au pack formation est reservé aux utilisateurs ayant souscrit à l'option.
                <br />
                Pour plus d'informations, vous vous invitions à nous contacter à l'adresse suivante : contact@mako-remexpert.com
                <br />
                {/* <a href="mailto:contact@mako-remexpert.com">contact@mako-remexpert.com</a> */}
                <br />
                Le pack formation comprend les services ci dessous : <br />
                <br />- Un guide complet sur la protection sociale: 150 pages de détails pédagogiques sous forme de fiches sur la retraite et la prévoyance du chef d’entreprise.
                <br />- Des newsletters sur l'environnement sociale et fiscale du chef d'entreprise.
                <br />- Une base de contrats de prévoyance TNS intégrée sur votre espace MAKO (une trentaine de contrats du marché sont analysés sur différents critères : délai d’attente,
                exclusions, garanties, conditions de prise en charges des affections dorsales et psy, barème d’invalidité…).
                <br />- Une calculette de points AGIRC ARRCO permettant de contrôler les points acquis.
                <br />- Deux outils d’aide à la détermination et la déclaration du plafond PER dans le cadre de l’article 163 quatervicies du CGI : correction des anciens plafonds, calcul du
                plafond 2024.
                <br />- Un outil d’aide à la vente du PER : mise en évidence de l’efficacité du dispositif : raisonnement net de fiscalité et de PS à l’entrée et à la sortie.
                <br />
                <br />
              </Column>
            </Row>
          </Column>
        </Modal>
      </Column>
    </>
  );
};

export default ListeAudits;
